// deviceStore.ts
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { DeviceType } from "../utils/deviceUtils";

type State = {
  deviceType: DeviceType;
  setDeviceType: (d: DeviceType) => void;
};

export const useDeviceStore = create<State>()(
  persist(
    (set) => ({
      deviceType: "web",
      setDeviceType: (d) => set({ deviceType: d }),
    }),
    {
      name: "device-store",
      storage: createJSONStorage(() => sessionStorage), // or localStorage
      partialize: (s) => ({ deviceType: s.deviceType }),
    }
  )
);